import { create } from 'zustand'
import { setPublishedExercises } from '@/data/exercises'
import type { Challenge } from '@/domain/workout'
import {
  fetchPublishedChallenge,
  loadCachedChallenge,
  type PublishedChallenge,
} from '@/services/challengeRepository'

interface ChallengeStore {
  challenge: Challenge
  source: PublishedChallenge['source']
  syncing: boolean
  /** Busca la última versión publicada. No falla nunca: si no hay, no cambia nada. */
  sync: () => Promise<void>
}

function apply(published: PublishedChallenge) {
  setPublishedExercises(published.exercises)
  return { challenge: published.challenge, source: published.source }
}

const initial = loadCachedChallenge()
setPublishedExercises(initial.exercises)

export const useChallengeStore = create<ChallengeStore>((set, get) => ({
  challenge: initial.challenge,
  source: initial.source,
  syncing: false,

  sync: async () => {
    if (get().syncing) return
    set({ syncing: true })

    const published = await fetchPublishedChallenge(get().challenge.id)
    set(published ? { ...apply(published), syncing: false } : { syncing: false })
  },
}))
